import { Component, computed, input } from '@angular/core';
import { NotificationLayoutComponent } from '../../notification-detail-layout/notification-detail-layout.component';
import { NotificationStep, TeacherNotification } from '../../../core/models/notification.model';
import {
  SUBSCRIPTION_TYPE_DIAGNOSTIC,
  SUBSCRIPTION_TYPE_DIAGNOSTIC_MID,
  SUBSCRIPTION_TYPE_DIAGNOSTIC_POST,
} from '../../../core/constants/subscription';

@Component({
  selector: 'wf-completed-diagnostic-notification',
  imports: [
    NotificationLayoutComponent
  ],
  template: `
    <wf-notification-layout
      headerTitle="They did it! Your student(s) completed a Diagnostic 📊"
      [preambles]="[{
        text:'The student(s) below completed the WordFlight Diagnostic today. '
          + 'This is our robust, patented assessment of foundational skills — validated against the '
          + 'Woodcock-Johnson™ Assessment — and it gives you a detailed picture of where each student stands.'
      }]"
      [steps]="steps"
      [ids]="ids()"
      ctaLabel="Open Diagnostic Results"
      ctaRoute="/reports/system/diagnostic"
    >
      <table table class="table-wrap">
        <tr>
          <th class="th">Student</th>
          <th class="th">Date</th>
          <th class="th">Assessment</th>
        </tr>
        @for (notification of data(); track notification.alertID) {
          <tr>
            <td class="td">{{ notification.studentName }}</td>
            <td class="td"><span class="date-display">{{ notification.data['displaydate'] }}</span></td>
            <td class="td"><span class="badge-green">{{ getAssessment(notification.data.AssessmentType) }}</span></td>
          </tr>
        }
      </table>
    </wf-notification-layout>
  `,
  standalone: true
})
export class CompletedDiagnosticNotificationComponent {
  readonly data = input.required<TeacherNotification[] | null>();
  readonly ids = computed(() => {
    const notifications = this.data() ?? [];

    return { alerts: notifications.map(notification => notification.alertID) };
  });
  readonly steps: NotificationStep[] = [
    {
      title: 'Review the Diagnostic Results report',
      body: 'Head to the WordFlight Management Site, select <b>Diagnostic Results</b>, then click <b>View</b> next to the student to see their full report.'
    },
    {
      title: 'Share the results with your student',
      body: 'A brief review together is a great opportunity to celebrate their strengths and reinforce why daily WordFlight practice matters. This can also help students stay motivated.'
    },
    {
      title: 'Use the data to inform your instruction',
      body: 'Diagnostic results are great for informing small group assignments and monitoring growth over time. Reach out to your Partner Success Lead if you’d like help making the most of the data.',
      variant: 'green'
    },
  ];

  getAssessment(assessment: string): string {
    const assessmentValue = parseInt(assessment, 10);

    if (isNaN(assessmentValue)) return '';

    if (assessmentValue === SUBSCRIPTION_TYPE_DIAGNOSTIC) {
      return 'System Pre';
    } else if (assessmentValue == SUBSCRIPTION_TYPE_DIAGNOSTIC_MID) {
      return 'System Mid';
    } else if (assessmentValue === SUBSCRIPTION_TYPE_DIAGNOSTIC_POST) {
      return ' System Post';
    }

    return '';
  }
}
